<template>
  <div @keyup.enter="onFilter">
    <!-- follow layout WarrantySearchBar -->
    <b-row class="mb-3">
      <b-col
        cols="12"
        md="2"
      >
        <b-input-group>
          <date-picker
            placeholder="Từ ngày gửi"
            class="form-control form-control-sm"
            :config="dpConfigs.date"
            v-model="localParams.startDate"
          />
        </b-input-group>
      </b-col>
      <b-col
        cols="12"
        md="2"
      >
        <b-input-group>
          <date-picker
            placeholder="Đến ngày gửi"
            class="form-control form-control-sm"
            :config="dpConfigs.date"
            v-model="localParams.endDate"
          />
        </b-input-group>
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <SupplierAutosuggest
          v-model="localParams.providerId"
          allow-all
          placeholder="tên nhà cung cấp"
          :limit="15"
        />
      </b-col>
      <b-col
        cols="12"
        md="2"
      >
        <b-form-select
          size="sm"
          v-model="localParams.status"
          :options="statusOptions"
          value-field="id"
          text-field="name"
        >
          <template #first>
            <b-form-select-option :value="null">Tất cả trạng thái</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
      <b-col
        cols="12"
        md="2"
      >
        <b-form-select
          class="select-style"
          size="sm"
          v-model="localPageSize"
          :options="optionPageSize"
        >
          <template #first>
            <b-form-select-option :value="null">--Hiển thị--</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        md="2"
      >
        <b-form-select
          size="sm"
          v-model="localParams.companyId"
          :options="listCompany"
          value-field="id"
          text-field="name"
        />
      </b-col>
      <b-col
        cols="12"
        md="2"
      >
        <b-form-input
          size="sm"
          v-model="localParams.code"
          placeholder="Mã phiếu outsource"
        />
      </b-col>
      <b-col
        cols="12"
        md="2"
      >
        <b-form-input
          type="number"
          size="sm"
          v-model="localParams.billId"
          placeholder="ID bảo hành"
          @keyup.enter="onFilter"
        />
      </b-col>
    </b-row>
    <b-row class="mb-5 mt-5">
      <b-col md="1">
        <b-button
          class="font-weight-bold"
          variant="primary"
          style="width: 70px"
          size="sm"
          @click="onFilter"
          :disabled="isLoading"
        >
          Lọc
        </b-button>
      </b-col>
      <b-col md="1">
        <b-button
          style="font-weight: 600; width: auto; min-width: 120px"
          variant="secondary"
          size="sm"
          @click="onReset"
          :disabled="isLoading || activeFilterCount === 0"
        >
          Xóa bộ lọc
          <span v-if="activeFilterCount > 0">({{ activeFilterCount }})</span>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import timeUtils from '@/utils/date'
import { WARRANTY_OUTSOURCE_STATUS } from '@/utils/enum'
import { WARRANTY_OUTSOURCE_STATUS_NAME } from '@/utils/enum-name'
import SupplierAutosuggest from '@/view/components/suppliers/SupplierAutosuggest.vue'

export default {
  name: 'OutsourceSearchBar',
  components: { SupplierAutosuggest },
  props: {
    params: { type: Object, default: () => ({}) },
    pageSize: { type: Number, default: null },
    optionStores: { type: Array, default: () => [] },
    optionPageSize: { type: Array, default: () => [10, 25, 50, 100] },
    isLoading: { type: Boolean, default: false },
    listCompany: { type: Array, default: () => [] },
  },
  data() {
    return {
      dpConfigs: timeUtils.DP_CONFIG,
      localParams: { ...this.params },
      localPageSize: this.pageSize,
      statusOptions: [
        {
          id: WARRANTY_OUTSOURCE_STATUS.SENT,
          name: WARRANTY_OUTSOURCE_STATUS_NAME[WARRANTY_OUTSOURCE_STATUS.SENT],
        },
        {
          id: WARRANTY_OUTSOURCE_STATUS.RECEIVED,
          name: WARRANTY_OUTSOURCE_STATUS_NAME[WARRANTY_OUTSOURCE_STATUS.RECEIVED],
        },
      ],
    }
  },
  computed: {
    activeFilterCount() {
      const params = this.localParams
      let count = 0
      if (params.code && String(params.code).trim()) count++
      if (params.billId && String(params.billId).trim()) count++
      if (params.startDate) count++
      if (params.endDate) count++
      if (params.status != null && params.status !== '') count++
      if (params.providerId != null && params.providerId !== '') count++
      if (params.companyId) count++
      return count
    },
  },
  watch: {
    params: {
      handler(val) {
        this.localParams = { ...val }
      },
      deep: true,
    },
    pageSize(val) {
      this.localPageSize = val
    },
    localPageSize(val) {
      this.$emit('page-size-change', val)
    },
  },
  methods: {
    onFilter() {
      this.$emit('filter', this.localParams)
    },
    onReset() {
      this.localParams = {
        startDate: null,
        endDate: null,
        status: null,
        providerId: null,
        storeId: null,
        code: null,
        billId: null,
        companyId: null,
      }
      this.localPageSize = null
      this.$emit('reset', this.localParams)
    },
  },
}
</script>
